import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function getMeterType(condition) {
  return request({
    url: cmsServerContext + '/meterType/list',
    method: 'post',
    data: condition
  })
}
export function getMeterlist() {
  return request({
    url: cmsServerContext + '/meterType/listMeter',
    method: 'get',

  })
}
